<script>
    let fieldSequence = 0

    export default {
        name: "FieldProxyMixin",

        props: {
            id: {
                type: String,
                default: () => `field-proxy-${fieldSequence++}`,
            },

            required: {
                type: Boolean,
            },

            validations: {
                type: Object,
            },

            value: {
                type: [String, Number, Boolean, Date, Object, Array],
            },
        },

        computed: {
            inputVal: {
                get() {
                    return this.fromModel(this.value)
                },
                set(val) {
                    this.$emit("input", this.toModel(val))
                },
            },
        },

        mounted() {
            this.getField().addValidationSource(this.validationSource)
        },

        beforeDestroy() {
            this.getField().removeValidationSource(this.validationSource)
        },

        methods: {
            getField() {
                return this.$refs.field
            },

            fromModel(val) {
                return val
            },

            toModel(val) {
                return val
            },

            validationSource: function(target, field) {
            },

            focus() {
                this.getField().focus()
            },

            scrollIntoView(opts) {
                this.getField().scrollIntoView(opts)
            },

            reset() {
                this.getField().reset()
            },

            setValidity(valid, errors) {
                this.getField().setValidity(valid, errors)
            },

            touch() {
                this.getField().touch()
            },

            validate() {
                this.getField().validate()
            },

            addValidationSource(source) {
                this.getField().addValidationSource(source)
            },

            removeValidationSource(source) {
                this.getField().removeValidationSource(source)
            },

            getRemoteValidator() {
                return this.getField()?.getRemoteValidator()
            }
        },
    }
</script>
